<template>
  <div @blur.capture="handleBlur">
    <VueDatePicker
      v-bind="$attrs"
      :min-date="minDate"
      :max-date="maxDate"
      v-on="$listeners"
      @input="handleInput"
    />
  </div>
</template>

<script>
import VueDatePicker from 'plugins/vue-datepicker'

function calcMinBirthDate() {
  const date = new Date()
  date.setFullYear(date.getFullYear() - 66)
  return date.toISOString().slice(0, 10)
}

function calcMaxBirthDate() {
  const date = new Date()
  date.setFullYear(date.getFullYear() - 18)
  return date.toISOString().slice(0, 10)
}

export default {
  name: 'DatePicker',

  props: {
    minDate: {
      type: String,
      default: () => calcMinBirthDate(),
    },
    maxDate: {
      type: String,
      default: () => calcMaxBirthDate(),
    },
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value)
    },

    handleBlur(event) {
      this.$emit('blur', event)
    },
  },
}
</script>

<style scoped lang="scss">
/* stylelint-disable declaration-no-important */
::v-deep .vd-wrapper {
  input {
    font-size: 16px;
    min-height: 50px;

    &::placeholder {
      color: #1e1f1f !important;
      font-size: 14px;
    }
  }
}
/* stylelint-enable declaration-no-important */
</style>
